import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import RootRef from '@material-ui/core/RootRef';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import red from '@material-ui/core/colors/red';
import grey from '@material-ui/core/colors/grey';
import common from '@material-ui/core/colors/common';
import ClearIcon from '@material-ui/icons/Clear';
import EditLocationIcon from '@material-ui/icons/EditLocation';
import { routePage } from '../store/route-page';
import { orderedColors } from '../helpers/schedules-colors';

// Split Cell into more classes to avoid HoC collision between react-beautiful-dnd HoC and translate
class CellText extends Component {
  render() {
    const { t, address: { uuid, street, postalCode, locality = '', schedule, notGeolocated } } = this.props;
    const textStyle = { lineHeight: 1.25 };
    const scheduleStyle = { color: orderedColors[schedule] };
    const notGeolocatedStyle = { color: red[800] };
    if (notGeolocated) {
      return (
        <Typography variant="body2" style={textStyle}>
          {`# ${uuid}`}
          <br/>
          {street}
          <br/>
          {`${postalCode} ${locality}`}
          <br/>
          <span style={scheduleStyle}>{t(`schedules.${schedule}`)}</span>
          <br/>
          <span style={notGeolocatedStyle}>{t('help.list.notGeolocated')}</span>
        </Typography>
      );
    }
    return (
      <Typography variant="body2" style={textStyle}>
        {`# ${uuid}`}
        <br/>
        {street}
        <br/>
        {`${postalCode} ${locality}`}
        <br/>
        <span style={scheduleStyle}>{t(`schedules.${schedule}`)}</span>
      </Typography>
    );
  }
}

CellText.propTypes = {
  t: PropTypes.func.isRequired,
  address: PropTypes.object,
};

const WrappedCellText = withNamespaces()(CellText);

class DeleteButton extends Component {
  render() {
    const { t } = this.props;
    return (
      <Tooltip title={t('buttons.delete')}>
        <IconButton disabled={!routePage.editable} onClick={this.props.onClick}>
          <ClearIcon nativeColor={red[700]}/>
        </IconButton>
      </Tooltip>
    );
  }
}

DeleteButton.propTypes = {
  t: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
};

const WrappedDeleteButton = withNamespaces()(DeleteButton);

class EditLocationButton extends Component {
  render() {
    const { t } = this.props;
    return (
      <Tooltip title={t('buttons.editLocationInAnotherWindow')}>
        <IconButton disabled={!routePage.editable} onClick={this.props.onClick}>
          <EditLocationIcon/>
        </IconButton>
      </Tooltip>
    );
  }
}

EditLocationButton.propTypes = {
  t: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
};

const WrappedEditLocationButton = withNamespaces()(EditLocationButton);

class Cell extends Component {
  constructor(props) {
    super(props);
    this.onDelete = this.onDelete.bind(this);
    this.onEditLocation = this.onEditLocation.bind(this);
  }

  onDelete() {
    this.props.onDelete(this.props.address.key);
  }

  onEditLocation() {
    const { publicEditing: { hash } } = this.props.address;
    window.open(`https://geo-correction.gls-spain.es/editExpeditionByHash/${hash}`, '_blank');
  }

  render() {
    const { provided, address: { order } } = this.props;
    const contentStyle = { boxSizing: 'content-box', backgroundColor: common.white, margin: '-1px -1px 0', border: `1px solid ${grey[400]}` };
    const draggableStyle = { padding: '4px 0' };
    const orderStyle = { flexShrink: 0, width: '64px' };
    const textStyle = { flexGrow: 1 };
    const leftButtonStyle = { flexShrink: 0, padding: '4px 0' };
    const rightButtonStyle = { flexShrink: 0, padding: '4px 4px 4px 0' };
    return (
      <RootRef rootRef={provided.innerRef}>
        <Grid container wrap="nowrap" {...provided.draggableProps}>
          <Grid container item wrap="nowrap" alignItems="center" style={contentStyle}>
            <Grid container item wrap="nowrap" alignItems="center" style={draggableStyle} {...provided.dragHandleProps}>
              <Grid item style={orderStyle}>
                <Typography variant="h6" align="center">{order}</Typography>
              </Grid>
              <Grid item style={textStyle}>
                <WrappedCellText address={this.props.address}/>
              </Grid>
            </Grid>
            <Grid item style={leftButtonStyle}>
              <WrappedEditLocationButton onClick={this.onEditLocation}/>
            </Grid>
            <Grid item style={rightButtonStyle}>
              <WrappedDeleteButton onClick={this.onDelete}/>
            </Grid>
          </Grid>
        </Grid>
      </RootRef>
    );
  }
}

Cell.propTypes = {
  provided: PropTypes.any,
  address: PropTypes.object,
  onDelete: PropTypes.func,
};

export default Cell;



// WEBPACK FOOTER //
// ./src/components/Cell.js